package music.jammers.client.shared.event.track.presentation.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import music.jammers.client.shared.component.getInstrumentByType
import music.jammers.client.shared.component.optionalInstrumentColor
import music.jammers.client.shared.event.track.presentation.model.UpdateInstrument
import org.jetbrains.compose.resources.painterResource

@Composable
fun UpdateInstrumentImage(
    updateInstrument: UpdateInstrument,
    onClick: (UpdateInstrument) -> Unit,
    modifier: Modifier = Modifier,
) {
    val instrument = getInstrumentByType(updateInstrument.eventInstrument.instrument)
    val icon = instrument.icon

    val tintColor = when (updateInstrument.status.value) {
        UpdateInstrument.Status.OPTIONAL -> {
            MaterialTheme.colorScheme.primary
        }

        UpdateInstrument.Status.REQUIRED -> {
            instrument.iconColor
        }

        UpdateInstrument.Status.NOT_REQUIRED -> {
            MaterialTheme.colorScheme.onSurface
        }
    }

    val backgroundColor = when (updateInstrument.status.value) {
        UpdateInstrument.Status.OPTIONAL -> {
            optionalInstrumentColor
        }

        UpdateInstrument.Status.REQUIRED -> {
            MaterialTheme.colorScheme.secondaryContainer
        }

        UpdateInstrument.Status.NOT_REQUIRED -> {
            MaterialTheme.colorScheme.surface
        }
    }

    Box(
        modifier = modifier
            .size(54.dp)
            .clip(shape = CircleShape)
            .background(
                color = backgroundColor,
            )
            .clickable(onClick = {
                onClick(updateInstrument)
            }),
    ) {
        Icon(
            painter = painterResource(icon),
            tint = tintColor,
            contentDescription = "Instrument",
            modifier = Modifier.align(Alignment.Center),
        )
    }
}